const getters = {
  isLoading: state => state.isLoading,
  isUpdating: state => state.isUpdating,
  isUploading: state => state.isUploading,
  isPaginating: state => state.isPaginating,
  all: state => state.all,
  hasEmpty: state => state.hasEmpty,
  filter: state => state.filter,
  isShowLoading: state => state.isShowLoading,
  excludeList: state => state.excludeList,
  header: state => state.header,
  getSlab: state => state.slabData,
};

export default getters;
